import type { ColDef, CellRendererSelectorFunc, ICellRendererParams, ValueFormatterFunc } from 'ag-grid-community';

export function cellRendererSelectorForPinnedRow(pinnedComponent: unknown): CellRendererSelectorFunc {
  return (params: ICellRendererParams) =>
    params.node?.rowPinned ? { component: pinnedComponent } : undefined;
}

export function mergePinnedRowValueFormatter(
  colDef: ColDef,
  pinnedFormatter: ValueFormatterFunc<any, any, any>,
): ColDef {
  const base = colDef.valueFormatter;
  return {
    ...colDef,
    valueFormatter: (params) => {
      if (params.node?.rowPinned) {
        return pinnedFormatter(params as any);
      }
      if (typeof base === 'function') {
        return (base as ValueFormatterFunc<any, any, any>)(params as any);
      }
      return params.value as any;
    },
  };
}
